<template>
  <div class="education-concept-wrapper">
    <div class="education-concept">
      <div class="education-concept-title">
        {{ config.title }}
      </div>
      <div class="education-concept-list">
        <div v-for="(item,index) in config.listData" :key="`education-concept-${index}`" class="education-concept-item">
          <div class="education-concept-img" v-lazy-background :lazy-background="item.picture">
            <span class="education-concept-tag">{{ item.tag }}</span>
          </div>
          <div class="education-concept-item-title">
            {{ item.title }}
          </div>
          <div class="education-concept-item-desc">
            {{ item.desc }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    config: {
      default: () => {},
      type: Object,
    },
  },
  data() {
    return {
    }
  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>
.education-concept-wrapper {
  padding: 80px 0;
  background: #f4f6fa;

  .education-concept {
    margin: 0 auto;
    padding: 0 120px;
    width: 1240px;
  }

  .education-concept-title {
    margin-bottom: 56px;
    font-size: 48px;
    font-weight: 600;
    color: var(--txt-color-lv1);
    line-height: 56px;
    text-align: center;
  }

  .education-concept-list {
    display: flex;
    justify-content: space-between;

    .education-concept-item {
      width: 473px;

      .education-concept-img {
        position: relative;
        margin-bottom: 16px;
        height: 266px;
        background-size: 473px 266px;
        background-repeat: no-repeat;
        border-radius: 18px;

        &::after {
          position: absolute;
          z-index: 1;
          left: 115px;
          bottom: 24px;
          content: '';
          height: 77px;
          width: 35px;
          background: var(--txt-color-link);
          border-radius: 10px;
          transform: skewX(10deg);
        }
      }

      .education-concept-tag {
        position: absolute;
        z-index: 2;
        left: -16px;
        bottom: 24px;
        padding-left: 16px;
        height: 77px;
        width: 160px;
        font-size: 32px;
        font-weight: 600;
        color: #fff;
        line-height: 77px;
        background: var(--txt-color-link);
        border-radius: 10px;
      }

      // .education-concept-img-1 {
      //   background-image: url('~assets/images/about-us/education-concept-1.jpg');
      // }

      // .education-concept-img-2 {
      //   background-image: url('~assets/images/about-us/education-concept-2.jpg');
      // }

      .education-concept-item-title {
        margin-bottom: 10px;
        font-size: 24px;
        font-weight: 600;
        color: var(--txt-color-lv1);
        line-height: 33px;
      }

      .education-concept-item-desc {
        width: 455px;
        font-size: 20px;
        font-weight: 500;
        color: var(--txt-color-lv3);
        line-height: 28px;
      }
    }
  }
}
</style>
